import 'rxjs';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { Segment, SegmentRelation, ServiceMapping, ServiceMaster, ServiceType, SubSegment } from '../shared/';
import { ServiceMapOptions } from '../shared/models/servicemap-options.model';
import { Constants } from '../shared/constants';

@Injectable()
export class ServiceMappingApi {
	private jsonurl = '/assets/db_json/';
	private token = localStorage.getItem('token');
	private headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token });
	// private options = new RequestOptions({ headers: this.headers });
	// private o = new HttpRequest({headers: this.headers})
	// private url = 'http://localhost:65090/api/servicemapping';

	private url = Constants.devServerEndpoint + 'api/servicemapping';

	constructor(private httpClient: HttpClient) { }

	public getSegments(): Observable<Segment[]> {
		return this.httpClient.get(this.jsonurl + 'Segments.json')
			.pipe(map((response: any) => response.json().Segments));
	}

	public getSegmentRelations(): Observable<SegmentRelation[]> {
		return this.httpClient.get(this.jsonurl + 'SegmentRelations.json')
			.pipe(map((response: any) => response.json().SegmentRelations));
	}

	public getServiceTypes(): Observable<ServiceType[]> {
		return this.httpClient.get(this.jsonurl + 'ServiceTypes.json')
			.pipe(map((response: any) => response.json().ServiceTypes));
	}

	public getSubSegments(): Observable<SubSegment[]> {
		return this.httpClient.get(this.jsonurl + 'SubSegments.json')
			.pipe(map((response: any) => response.json().SubSegments));
	}

	public getServiceMaster(): Observable<ServiceMaster[]> {
		return this.httpClient.get(this.url + '/servicemaster', { headers: this.headers })
			.pipe(
				map((response: ServiceMaster[]) => response));
	}

	public getServiceMapping(): Observable<ServiceMapping[]> {
		return this.httpClient.get(this.url, { headers: this.headers })
			.pipe(
				map((response: ServiceMapping[]) => response)
			);
	}

	public postServiceMapping(serviceMapOption: ServiceMapOptions): Observable<any> {
		return this.httpClient.post(this.url, serviceMapOption, { headers: this.headers });
	}

	private errorHandler(error: any): void {
		console.log(error);
	}
}
